var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { DossierInfo, DossierStep, useDossierContext, useDossierUpdateOrchestration } from 'common-app/dossier';
import { OverlayTrigger, Spinner, Tooltip } from '@isyc-react/design/bootstrap';
import { FormProvider, RhfListForm, RhfListItemView, useForm, useWatch, } from '@isyc-react/form/modules/rhf';
import clsx from 'clsx';
import { OccupantForm, OccupantSummary } from './occupant-form.component';
import { useOccupantWriteMutationPromise } from 'common-app/api/query/occupant-write';
import { occupantApiToForm, occupantFormToApi } from './occupant-form.mapper';
import { useOccupantCreateMutationPromise } from 'common-app/api/query/occupant-create';
import { useErrorNotification } from '@isyc-react/form/modules/context/notification-hub';
import { useTranslation } from 'react-i18next';
import { namespaces } from 'i18n/i18n.constants';
const AddOccupant = props => {
    const { dossier } = useDossierContext();
    const { append, disabled } = props;
    const [loading, setLoading] = React.useState(false);
    const createOccupant = useOccupantCreateMutationPromise();
    const addErrorNotification = useErrorNotification();
    return (React.createElement("div", { className: clsx('d-flex align-items-center font-size-14 fw-bold text-uppercase mb-5 mb-sm-0', {
            'cursor-pointer text-secondary': !loading && !disabled,
            'cursor-default text-muted': loading || disabled,
        }), onClick: () => {
            if (!loading && !disabled) {
                setLoading(true);
                createOccupant({ dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id })
                    .then(result => {
                    var _a;
                    const occupant = (_a = result.data) === null || _a === void 0 ? void 0 : _a.create_occupant;
                    if (occupant) {
                        append(occupantApiToForm(occupant));
                    }
                })
                    .catch(err => {
                    addErrorNotification('Une erreur est survenue lors de la création du occupant', { life: 5000 });
                    console.error('Error', err);
                })
                    .finally(() => setLoading(false));
            }
        } },
        React.createElement("u", null,
            React.createElement("span", null, "+ "),
            React.createElement("span", null, "Ajouter un occupant")),
        loading && React.createElement(Spinner, { animation: 'border', size: 'sm', className: 'text-secondary ms-2' })));
};
export const OccupantListFormContainer = props => {
    const { children, prepend, length, append, canAdd } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: clsx('d-flex align-items-center', { 'mb-3': length > 0 }) },
            React.createElement("h1", { className: 'text-black fw-600 font-size-20' })),
        length === 0 && React.createElement("div", null, "Il n'y a pas d'autres occupants"),
        children,
        canAdd && React.createElement(AddOccupant, { append: append })));
};
export const DossierOccupants = props => {
    const { dossier } = useDossierContext();
    const { others } = props;
    const [loading, setLoading] = React.useState(false);
    const [updateStep, { loading: loadingOrchestration }] = useDossierUpdateOrchestration();
    const writeOccupants = useOccupantWriteMutationPromise();
    const addErrorNotification = useErrorNotification();
    const { t } = useTranslation(namespaces.common);
    const methods = useForm({
        mode: 'onTouched',
        defaultValues: {
            others: others.map(occupantApiToForm),
        },
    });
    const { handleSubmit, getValues, control, watch } = methods;
    const onFormSuccess = (data) => __awaiter(void 0, void 0, void 0, function* () {
        const { others } = data;
        if (others) {
            setLoading(true);
            // TODO error notification and awaitableApollo ...
            yield writeOccupants({ dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, participants: others.map(o => occupantFormToApi(o)) })
                .then(() => __awaiter(void 0, void 0, void 0, function* () {
                yield updateStep({ variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, step: DossierStep.SUMMARY } });
            }))
                .catch(err => {
                addErrorNotification(`Une erreur est survenue lors de la sauvegarde des occupants`, { life: 5000 });
                console.error('Error', err);
            })
                .finally(() => setLoading(false));
        }
    });
    const onFormError = data => {
        addErrorNotification('Tous les champs obligatoires ne sont pas correctement renseignés', { life: 10000 });
    };
    // const occupantNameasdasd = watch(`others.0.surname`)
    return (React.createElement(React.Fragment, null,
        React.createElement(DossierInfo, null),
        React.createElement("div", { className: 'px-5 px-md-0' },
            React.createElement("div", null,
                React.createElement("h1", { className: 'text-black fw-600 font-size-20 pt-5 pt-md-0' },
                    React.createElement("span", null, "Occupants non titulaires du bail"),
                    React.createElement(OverlayTrigger, { delay: { show: 250, hide: 0 }, overlay: React.createElement(Tooltip, null, "Il s'agit des autres personnes occupants votre logement. Exemple : enfant, parent...") },
                        React.createElement("i", { className: 'mdi mdi-information text-light-secondary ms-2' })))),
            React.createElement("p", { className: 'mb-0' }, "Vos informations sont pr\u00E9remplies avec les derni\u00E8res informations \u00E0 notre connaissance. Veuillez les valider, les compl\u00E9ter ou les modifier si votre situation a chang\u00E9."),
            React.createElement("p", { className: 'mb-0' }, "En fonction de votre d\u00E9claration, des justificatifs seront \u00E9ventuellement \u00E0 fournir. Les donn\u00E9es marqu\u00E9es avec un ast\u00E9risque * sont obligatoires.")),
        React.createElement(FormProvider, Object.assign({}, methods),
            React.createElement("div", { className: 'px-5 py-4' },
                React.createElement("form", { onSubmit: handleSubmit(onFormSuccess, onFormError) },
                    React.createElement(RhfListForm, { getValues: getValues, initialView: RhfListItemView.EXPANDED, sortable: true, newItemDefaultValue: null, removable: p => Boolean(p.erasable), rhf: { control, name: `others` }, Container: OccupantListFormContainer, ItemTitle: ({ index, length }) => {
                            const surname = useWatch({ name: `others.${index}.surname` });
                            const firstname = useWatch({ name: `others.${index}.firstname` });
                            return React.createElement("div", { className: 'fw-bold' }, `Occupant : ${surname} ${firstname}`);
                        }, ItemSummaryView: OccupantSummary, ItemFormView: ({ index }) => (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: 'row' },
                                React.createElement(OccupantForm, { name: `others.${index}` })))) }),
                    React.createElement("div", { className: 'd-flex align-items-center justify-content-between mt-4 flex-column-reverse flex-sm-row gap-3 buttons mb-3' },
                        React.createElement("button", { onClick: () => updateStep({ variables: { dossierId: dossier === null || dossier === void 0 ? void 0 : dossier.id, step: DossierStep.SIGNATORIES } }), type: 'button', className: 'btn btn-link btn-lg', disabled: loading || loadingOrchestration },
                            React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                                loadingOrchestration ? (React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                                    React.createElement(Spinner, { animation: 'border', className: 'text-dark-primary', size: 'sm' }))) : (React.createElement("i", { className: 'text-dark-primary mdi mdi-chevron-left' })),
                                React.createElement("div", { className: 'ms-3' }, "Retour"))),
                        React.createElement("button", { type: 'submit', className: 'btn btn-secondary btn-lg fw-500', disabled: loading || loadingOrchestration },
                            React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                                React.createElement("div", { className: 'me-2' }, "Passer \u00E0 la rubrique suivante"),
                                loading ? (React.createElement(Spinner, { animation: 'border', size: 'sm' })) : (React.createElement("i", { className: 'mdi mdi-check text-white font-size-16 d-block' })))))),
                React.createElement("span", null, t('bailleurs.footer.card'))))));
};
